module.exports = __webpack_public_path__ + "static/media/logo2.6ae032d9.png";